module.exports = {
  phone: '07860 828605',
  email: 'alison@ag-therapy.com',
  sitemessage: 'I am currently unable to see any new clients'
};
